/* NAILSY hair-growth serum landing — interactions
   Scoped to .hairserum-scope. Safe to load once per page. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.hsInit) return;
    root.dataset.hsInit = '1';

    /* ---------- FAQ accordions ---------- */
    root.querySelectorAll('.hs-acc-q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.hs-acc-item');
        var open = item.classList.contains('is-open');
        var acc = btn.closest('.hs-accordion');
        if (acc) acc.querySelectorAll('.hs-acc-item.is-open').forEach(function (i) {
          i.classList.remove('is-open');
          var a = i.querySelector('.hs-acc-a'); if (a) a.style.maxHeight = null;
        });
        if (!open) {
          item.classList.add('is-open');
          var a = item.querySelector('.hs-acc-a');
          if (a) a.style.maxHeight = a.scrollHeight + 'px';
        }
      });
    });

    /* ---------- carousel arrow scrollers ---------- */
    root.querySelectorAll('[data-hs-arrows]').forEach(function (group) {
      var target = root.querySelector(group.getAttribute('data-hs-arrows'));
      if (!target) return;
      group.querySelectorAll('[data-dir]').forEach(function (b) {
        b.addEventListener('click', function () {
          var card = target.querySelector('.hs-ing-card,.hs-story');
          var step = card ? card.getBoundingClientRect().width + 20 : 320;
          target.scrollBy({ left: (b.getAttribute('data-dir') === 'next' ? step : -step), behavior: 'smooth' });
        });
      });
    });

    /* ---------- plan selector (buy box) ---------- */
    var atcButtons = root.querySelectorAll('[data-hs-atc]');
    function syncPlan(plan) {
      root.querySelectorAll('.hs-plan').forEach(function (p) { p.classList.toggle('is-active', p === plan); });
      var vid = plan.getAttribute('data-vid') || '';
      var price = plan.getAttribute('data-price') || '';
      var old = plan.getAttribute('data-old') || '';
      atcButtons.forEach(function (b) { if (vid) b.setAttribute('data-vid', vid); });
      // update sticky bar price
      var sp = root.querySelector('[data-hs-sticky-price]');
      if (sp) sp.innerHTML = price + (old ? ' <s>' + old + '</s>' : '');
    }
    var plans = root.querySelectorAll('.hs-plan');
    plans.forEach(function (plan) {
      plan.addEventListener('click', function () { syncPlan(plan); });
    });
    var pre = root.querySelector('.hs-plan.is-active') || plans[0];
    if (pre) syncPlan(pre);

    /* ---------- add to cart -> open elixir <cart-drawer> ---------- */
    atcButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var vid = btn.getAttribute('data-vid');
        if (!vid) { flash(btn); return; }
        var drawer = document.querySelector('cart-drawer');
        var body = { items: [{ id: Number(vid), quantity: 1 }] };
        if (drawer && typeof drawer.getSectionsToRender === 'function') {
          body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
          body.sections_url = window.location.pathname;
        }
        var label = btn.textContent; btn.textContent = 'Dodajem…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        }).then(function (r) { return r.json(); }).then(function (res) {
          btn.textContent = label;
          if (drawer && typeof drawer.renderContents === 'function') {
            drawer.renderContents(res);
            if (typeof drawer.open === 'function') drawer.open();
          } else {
            window.location.href = '/cart';
          }
        }).catch(function () { btn.textContent = label; window.location.href = '/cart'; });
      });
    });

    function flash(btn) {
      var t = btn.textContent; btn.textContent = 'Dodano ✓';
      setTimeout(function () { btn.textContent = t; }, 1400);
    }

    /* ---------- sticky ATC bar reveal ---------- */
    var sticky = root.querySelector('.hs-sticky');
    var hero = root.querySelector('.hs-hero');
    if (sticky && hero) {
      window.addEventListener('scroll', function () {
        var past = hero.getBoundingClientRect().bottom < 0;
        sticky.classList.toggle('is-visible', past);
      }, { passive: true });
    }
  }

  function boot() {
    document.querySelectorAll('.hairserum-scope').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
